// B2B Variant Grid Interactivity
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.b2b-variant-card').forEach(function(card) {
    var variantId = card.dataset.variantId;
    
    // Custom Dropdown Elements
    var volumePricingWrap = card.querySelector('.volume-pricing-wrap');
    
    // Only proceed with dropdown logic if volume pricing element exists
    if (!volumePricingWrap) {
      // If there's no volume pricing, ensure the minimum quantity is respected if set
      var initialMinQty = parseInt(card.querySelector('.b2b-variant-card__qty').min, 10) || 1;
      card.querySelector('.b2b-variant-card__qty').value = initialMinQty;
      // Skip the rest of the dropdown setup
      console.log(`Variant ${variantId}: No volume pricing breaks found. Skipping dropdown setup.`);
    } else {
      var dropdownHeader = card.querySelector('[data-header-toggle]');
      var optionsList = card.querySelector('[data-options-list]');
      var selectedLabel = card.querySelector('.selected-label');

      // --- 1. Custom Volume Pricing Logic (UL/LI) ---
      
      // Toggle dropdown visibility
      dropdownHeader.addEventListener('click', function() {
        optionsList.classList.toggle('hidden');
      });

      // Handle selection of a tier
      card.querySelectorAll('.dropdown-option').forEach(function(option) {
        option.addEventListener('click', function() {
          var minQty = parseInt(option.dataset.min, 10) || 1;
          // Inner text contains HTML (<b>), so we use innerHTML
          var label = option.innerHTML.trim(); 
          
          // Update Quantity Input
          var qtyInput = card.querySelector('.b2b-variant-card__qty');
          qtyInput.min = minQty;
          // Set value to minimum quantity if current value is less
          qtyInput.value = minQty;

          // Update Dropdown Header Display
          selectedLabel.innerHTML = label;
          selectedLabel.dataset.minQty = minQty;
          
          // Highlight selected option and hide dropdown
          card.querySelectorAll('.dropdown-option').forEach(o => o.classList.remove('selected'));
          option.classList.add('selected');
          optionsList.classList.add('hidden');
        });
      });

      // Close dropdown if clicking outside
      document.addEventListener('click', function(e) {
        if (!card.querySelector('.custom-dropdown-wrap').contains(e.target)) {
          optionsList.classList.add('hidden');
        }
      });
    }

    // --- 2. Quantity Picker Logic ---
    
    var qtyInput = card.querySelector('.b2b-variant-card__qty');
    var minusBtn = card.querySelector('.b2b-variant-card__qty-btn[data-action="minus"]');
    var plusBtn = card.querySelector('.b2b-variant-card__qty-btn[data-action="plus"]');
    
    minusBtn.addEventListener('click', function() {
      var min = parseInt(qtyInput.min, 10) || 1;
      var val = parseInt(qtyInput.value, 10) || min;
      if (val > min) qtyInput.value = val - 1;
    });

    plusBtn.addEventListener('click', function() {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
    });
    
    // --- 3. AJAX Add to Cart Logic ---

    var addBtn = card.querySelector('.b2b-variant-card__add');
    var status = card.querySelector('.b2b-variant-card__status');

    addBtn.addEventListener('click', function() {
      var quantity = parseInt(qtyInput.value, 10) || 1;
      var id = variantId;
      
      // Reset status and disable button
      status.textContent = '';
      status.classList.add('hidden');
      status.classList.remove('success', 'error');
      addBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: quantity })
      })
      .then(function(res) {
        if (!res.ok) {
          return res.json().then(data => { throw new Error(data.description || 'Failed to add to cart.'); });
        }
        return res.json();
      })
      .then(function(data) {
        addBtn.disabled = false;
        
        // Success Message
        status.textContent = 'Added ' + quantity + ' item(s) to cart!';
        status.classList.add('success');
        status.classList.remove('hidden');

        // Broadcast event to update theme's cart count/drawer
        document.dispatchEvent(new CustomEvent('cart:add', { detail: { id: id, quantity: quantity } }));
        
        // Hide message after 3 seconds
        setTimeout(() => status.classList.add('hidden'), 3000);
      })
      .catch(function(err) {
        addBtn.disabled = false;
        
        // Error Message
        status.textContent = err.message || 'Error adding to cart.';
        status.classList.add('error');
        status.classList.remove('hidden');
      });
    });
  });
});